export default {
  main: '#C3BDB4',
  secondary: '#8C4036',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#C3BDB4',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
